import React, { useEffect, useState } from "react";
import SideMenu from "../General/SideMenu";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import CustomizedSelectoption from "../General/CustomizedSelectoption";
import CustomTransView from "../Transaction/CustomTransView";
import { Ask_Question, Show_Message } from "../General/Messagedialogbox";
import { ShowHide_Popup } from "../features/Transactionstates";
import Messagedialogbox from "../General/Messagedialogbox";
import { API_FETCH, API_POST, DecryptData } from "../General/Utility";
import {
  Change_Unit,
  ProductRate_Onchange,
  Modify_InventoryProduct,
  Clear_Product,
  StockAdjutment_Onchange,
  StockQty_Onchange,
  Select_Unit,
} from "../features/Transactionstates";
import MasterProductSearch from "../Transaction/MasterProductSearch";
import ReactTable from "../General/ReactTable";

function StockAdjustment() {
  const dispatch = useDispatch();
  const _Proparem = useSelector((state) => state.Transstates.Product);
  const _selecrparem = useSelector((state) => state.SelectOption.parems);
  const _Common = useSelector((store) => store.Transstates.Common);
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const iScrId = 38;
  const [selected, setselected] = useState(0);
  const [isTrans, setisTrans] = useState(false);
  const [isBtnView, setisBtnView] = useState(false);
  const [isBtnSave, setisBtnSave] = useState(false);
  const [isBtnDelete, setisBtnDelete] = useState(false);
  const [isProduct, setisProduct] = useState(false);

  const [strTransNo, setstrTransNo] = useState("");
  const [strVouchNo, setstrVouchNo] = useState("");
  const [strVouchDate, setstrVouchDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [iStoAdjId, setiStoAdjId] = useState(0);
  const [strDescription, setstrDescription] = useState("");

  const [dNetAmt, setdNetAmt] = useState(0);
  const [dTQty, setdTQty] = useState(0);
  const [dGoodVal, setdGoodVal] = useState(0);
  const [dRoundOff, setdRoundOff] = useState(0);

  const [NoFormat, setNoFormat] = useState([]);
  const [EntTransDT, setEntTransDT] = useState([]);
  const [ListValidateProperties, setListValidateProperties] = useState([]);
  const [ListTabOrder, setListTabOrder] = useState({
    txtTransNo: "",
    txtStoAdjNo: "",
    dpStoAdjDate: "",
    txtDescription: "",
    btnNew: "",
    btnModify: "",
    btnSave: "",
    btnClear: "",
    btnView: "",
    btnExportImport: "",
    btnPrint: "",
    btnCancel: "",
    btnClose: "",
    btnPrintSettings: "",
    btnHelp: "",
    TopCenterVoucher: "",
    TopRightDelivery: "",
    MiddleRightSummary: "",
    ProductTableListTab: "",
    txtProductName: "",
    txtQty: "",
    cbUnit: "",
    txtRate: "",
    txtReason: "",
    btnAdd: "",
  });

  useEffect(() => {
    Load_StockAdjustment();
    ButtonPermission();
  }, []);

  const Load_StockAdjustment = async () => {
    try {
      const _LocalParem = await DecryptData(localStorage.jbctrlparams);

      const res = await API_FETCH(
        `StockAdjustment/Load_StockAdjustment/${Number(_LocalParem.Branch)}/${_LocalParem.DB}`,
        dispatch
      );

      if (res && res.NoFormat && res.NoFormat.length > 0) {
        console.log("FULL RES:", res);
        setNoFormat(res.NoFormat);
        setstrTransNo(res.NoFormat[0].strTransNo || "");
        setstrVouchNo(res.NoFormat[0].strUserNo || "");
        //  BUG FIX 3: Populate validation + tab order (was missing — caused save issues)
        setListValidateProperties(res.EntProperties ?? []);
        TabOrderAssign(res.EntProperties ?? []);
      } else {
        console.log("Full res:", res);  // ← இதை போடு
        console.log("Keys:", Object.keys(res ?? {}));
      }
    } catch (err) {
      console.log("Load Error:", err);
    }
  };

  // FIX 4: Guard NoFormat[0] access with an early return check
  const SaveClick = async () => {
    if (EntTransDT.length === 0) {
      Show_Message(dispatch, "Atleast One Item is Required per Bill", "info");
      return;
    }

    if (!NoFormat || NoFormat.length === 0) {
      Show_Message(dispatch, "Transaction format not loaded. Please reload the screen.", "error");
      return;
    }

    const fmt = NoFormat[0];
    const StoAdjHT = {
      iTitleTag: iScrId,
      strTransNo: strTransNo,
      iNumSeqNo: fmt.iNumSeqNo,
      strPrefix: fmt.strPrefix,
      strCompCode: fmt.strCompCode,
      strFinanFrom: fmt.strFinanFrom,
      iStoAdjId: iStoAdjId,
      strVouchNo: strVouchNo,
      strVouchDate: strVouchDate,
      strDescription: strDescription,
      dTQty: Number(dTQty),
      dTGoodsValue: Number(dGoodVal),
      dRoundOff: Number(dRoundOff),
      dNetAmt: Number(String(dNetAmt).replace(/[^0-9.-]+/g, "")),
      iBranchId: Number(_AuthParems.Branch),
    };

    const res = await API_POST(
      "StockAdjustment/InsUpd_StockAdjustment/",
      {
        objEntItem: StoAdjHT,
        objBaseTransDT: EntTransDT,
        strDBName: _AuthParems.DB,
        iUserId: Number(_AuthParems.User),
      },
      dispatch
    );
    if (res) {
        console.log("ADD RES:", res)
      ClearClick();
      Show_Message(dispatch, res.strMessage, "success");
    }
  };

  const DeleteClick = async () => {
    if (iStoAdjId === 0) {
      Show_Message(dispatch, "Please Select Voucher to Delete!", "error");
    } else {
      const res = await API_POST(
        `StockAdjustment/Delete_StockAdjustment/${iStoAdjId}/${Number(
          _AuthParems.Branch
        )}/${_AuthParems.DB}`,
        dispatch
      );
      if (res) {
        ClearClick();
        Show_Message(dispatch, res.strMessage, "success");
      }
    }
  };

  // FIX 2: Use optional chaining on ItemRemark and listRootCalc
  const DeleteIconClick = async (iIndex) => {
    const res = await API_POST(
      "StockAdjustment/DeleteProduct/",
      {
        iRowIndex: iIndex,
        objBaseTransDT: EntTransDT,
        bUpdateStatus: _Proparem.bUpdateStatus,
        iProId: 0,
        dQty: 0,
        iUnitId: 0,
        dPriceRate: 0,
        strProAttDTId: "0",
        strStoAttDTId: "0",
        strTraAttDTId: "0",
        strReason: _Proparem.Reason,
        objEntAddLess: [],
        objEntConRow: [],
        objEntTax: [],
        objItemRemark: _Proparem.ItemRemark?.[0] ?? {},   // FIX 2
        objPenCon: [],
        objRootCalc: _Proparem.listRootCalc?.[0] ?? {},   // FIX 2
        strColumn: "",
        strJobId: "",
        strSearch: "",
        strSetCurrentStatus: "Yes",
        iYearId: Number(_AuthParems.Year),
        strDBName: _AuthParems.DB,
        iRoleId: Number(_AuthParems.User),
      },
      dispatch
    );
    if (res) {
      setEntTransDT(res.EntTransDT);
      const Summary = res.objStoAdjSummary ?? {};
      setdTQty(Number(Summary.qty ?? 0).toFixed(2));
      setdGoodVal(Number(Summary.goodsValue ?? 0).toFixed(2));
      setdRoundOff(Number(Summary.roundOff ?? 0).toFixed(2));
      setdNetAmt(Summary.netAmt ?? 0);
    }
  };

const ClearClick = () => {
    setEntTransDT([]);
    setstrDescription("");
    setdNetAmt(0);
    setdTQty(Number(0).toFixed(2));
    setdRoundOff(Number(0).toFixed(2));
    setdGoodVal(Number(0).toFixed(2));
    setiStoAdjId(0);          // ✅ FIX: reset pannanum, illana next save "Update" ah poyidum
    ClearProduct();
    Load_StockAdjustment();
  };

  // FIX 1: Added missing await + safe optional chaining on objEntHT[0]
  const View_StcokAdjustment = async (iVouchId) => {
    setiStoAdjId(iVouchId);
    const res = await API_FETCH(                          // FIX 1 — was missing await
      `StockAdjustment/View_Voucher/${iVouchId}/${Number(_AuthParems.Branch)}/${_AuthParems.DB}`,
      dispatch
    );
    if (res) {
       console.log("VIEW RES:", res);
      setstrTransNo(res.objEntHT?.[0]?.strTransNo ?? "");  // FIX 1
      setstrVouchNo(res.objEntHT?.[0]?.strVouchNo ?? "");  // FIX 1
      setstrVouchDate(res.objEntHT?.[0]?.strVouchDate ?? ""); // FIX 1
      setstrDescription(res.objEntHT?.[0]?.strDescription ?? ""); // FIX 1
      setEntTransDT(res.EntTransDT ?? []);
      $(".rt-tbody")
        .stop()
        .animate({
          scrollTop: 30 * ((res.EntTransDT?.length ?? 1) - 1),
        });
      const Summary = res.objEntSummary?.[0] ?? {};
      setdTQty(Number(Summary.qty ?? 0).toFixed(2));
      setdGoodVal(Number(Summary.goodsValue ?? 0).toFixed(2));
      setdRoundOff(Number(Summary.roundOff ?? 0).toFixed(2));
      setdNetAmt(Summary.netAmt ?? 0);
    }
  };

  const AssignSelectedProduct = async (Index, proinfo) => {
    const res = await API_FETCH(
      `Transaction/GetParticularProDetials/${proinfo.proId}/Purchase/${_AuthParems.DB}`,
      dispatch
    );
    if (res) {
      dispatch(
        Modify_InventoryProduct({
          ProInfo: {
            proId: proinfo.proId,
            proCode: proinfo.proCode,
            proName: proinfo.proName,
            unitId: proinfo.unitId,
            unitName: proinfo.unitName,
            rateWithoutTax: proinfo.rateWithoutTax,
            rateWithTax: proinfo.rateWithTax,
            qty: proinfo.qty,
            fQty: 0,
            reason: proinfo.reason,
            reasonId: 0,
            isBatchPro: 0,
            isComposPro: 0,
            whId: 0,
            twhId: 0,
            tBranchId: 0,
            jobId: "0",
            itemDiscPer: 0,
            itemDiscAmt: 0,
            cashDiscPer: 0,
            cashDiscAmt: 0,
            remark1: proinfo.remark1,
            remark2: proinfo.remark2,
            remark3: proinfo.remark3,
            remark4: proinfo.remark4,
            value1: 0,
            value2: 0,
            value3: 0,
            constantValue: 0,
            finalValue: 0,
          },
          Unit: res.objUnit ?? [],
          Index: Index,
        })
      );
    }
  };

const AddProductClick = async () => {
    if (_Proparem.strProName === "") {
      Show_Message(dispatch, "Please select Product", "info");
    } else if (Number(_Proparem.dQty) === 0) {
      Show_Message(dispatch, "Minimum Qty is Required", "info");
    } else if (!_Proparem.Reason || _Proparem.Reason.trim() === "") {
      Show_Message(dispatch, "Please Enter Adjustment Reason", "info");
    } else {
      const res = await API_POST(
        "StockAdjustment/Add_Product/",
        {
          bUpdateStatus: _Proparem.bUpdateStatus,
          iRowIndex: _Proparem.iRowIndex,
          iProId: _Proparem.iProId,
          dQty: _Proparem.dQty,
          iUnitId: _Proparem.iUnitId,
          dPriceRate: _Proparem.dRate,
          strProAttDTId: "0",
          strStoAttDTId: "0",
          strTraAttDTId: "0",
          objBaseTransDT: EntTransDT,
          strReason: _Proparem.Reason,
          objEntAddLess: [],
          objEntConRow: [],
          objEntTax: [],
          objItemRemark: _Proparem.ItemRemark?.[0] ?? {},
          objPenCon: [],
          objRootCalc: _Proparem.listRootCalc?.[0] ?? {},
          strColumn: "",
          strJobId: "",
          strSearch: "",
          strSetCurrentStatus: "Yes",
          iYearId: Number(_AuthParems.Year),
          strDBName: _AuthParems.DB,
          iRoleId: Number(_AuthParems.User),
          iBranchId: Number(_AuthParems.Branch),
        },
        dispatch
      );
      if (res) {
        setEntTransDT(res.EntTransDT);
        // FIX 3: Removed duplicate unsafe setter calls — keep only the safe ones
        const Summary = res.objEntSummary?.[0] ?? {};
        setdTQty(Number(Summary.qty ?? 0).toFixed(2));
        setdGoodVal(Number(Summary.goodsValue ?? 0).toFixed(2));
        setdRoundOff(Number(Summary.roundOff ?? 0).toFixed(2));
        setdNetAmt(Summary.netAmt ?? 0);
        ClearProduct();
      }
    }
  };

  const ClearProduct = () => {
    dispatch(Clear_Product());
  };

  const TabOrderAssign = (EntProperties) => {
    let TabOrder = ListTabOrder;
    EntProperties = EntProperties.filter((Data) => Data.isTabStop === true);
    for (var i = 0; i < EntProperties.length; i++) {
      switch (EntProperties[i].strCtrlName) {
        case "txtTransNo":
          TabOrder.txtTransNo = EntProperties[i].iTabIndex;
          break;
        case "txtStoAdjNo":
          TabOrder.txtStoAdjNo = EntProperties[i].iTabIndex;
          break;
        case "dpStoAdjDate":
          TabOrder.dpStoAdjDate = EntProperties[i].iTabIndex;
          break;
        case "txtDescription":
          TabOrder.txtDescription = EntProperties[i].iTabIndex;
          break;
        case "btnNew":
          TabOrder.btnNew = EntProperties[i].iTabIndex;
          break;
        case "btnModify":
          TabOrder.btnModify = EntProperties[i].iTabIndex;
          break;
        case "btnSave":
          TabOrder.btnSave = EntProperties[i].iTabIndex;
          break;
        case "btnClear":
          TabOrder.btnClear = EntProperties[i].iTabIndex;
          break;
        case "btnView":
          TabOrder.btnView = EntProperties[i].iTabIndex;
          break;
        case "btnExportImport":
          TabOrder.btnExportImport = EntProperties[i].iTabIndex;
          break;
        case "btnPrint":
          TabOrder.btnPrint = EntProperties[i].iTabIndex;
          break;
        case "btnCancel":
          TabOrder.btnCancel = EntProperties[i].iTabIndex;
          break;
        case "btnClose":
          TabOrder.btnClose = EntProperties[i].iTabIndex;
          break;
        case "btnPrintSettings":
          TabOrder.btnPrintSettings = EntProperties[i].iTabIndex;
          break;
        case "btnHelp":
          TabOrder.btnHelp = EntProperties[i].iTabIndex;
          break;
        case "TopCenterVoucher":
          TabOrder.TopCenterVoucher = EntProperties[i].iTabIndex;
          break;
        case "TopRightDelivery":
          TabOrder.TopRightDelivery = EntProperties[i].iTabIndex;
          break;
        case "MiddleRightSummary":
          TabOrder.MiddleRightSummary = EntProperties[i].iTabIndex;
          break;
        case "lbProduct":
          TabOrder.ProductTableListTab = EntProperties[i].iTabIndex;
          break;
        case "txtProductName":
          TabOrder.txtProductName = EntProperties[i].iTabIndex;
          break;
        case "txtQty":
          TabOrder.txtQty = EntProperties[i].iTabIndex;
          break;
        case "cbUnit":
          TabOrder.cbUnit = EntProperties[i].iTabIndex;
          break;
        case "txtRate":
          TabOrder.txtRate = EntProperties[i].iTabIndex;
          break;
        case "txtReason":
          TabOrder.txtReason = EntProperties[i].iTabIndex;
          break;
        case "btnAdd":
          TabOrder.btnAdd = EntProperties[i].iTabIndex;
          break;
        default:
          break;
      }
    }
    var maxTab = EntProperties.reduce(
      (prev, current) => (prev.iTabIndex > current.iTabIndex ? prev : current),
      0
    );
    sessionStorage.maxTab = maxTab.iTabIndex;
    setListTabOrder(TabOrder);
  };

  const KeyDown = (e) => {
    var maxTab = Number(sessionStorage.maxTab);
    var ActiveIndex = document.activeElement.tabIndex;
    if (e.key === "Enter") {
      if (ActiveIndex >= 1 && ActiveIndex < maxTab) {
        if (
          ActiveIndex + 1 === ListTabOrder.ProductTableListTab &&
          EntTransDT.length > 0
        ) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex + 1) + "']").select();
        }
      } else {
        $("[tabindex='" + 1 + "']").focus();
        $("[tabindex='" + 1 + "']").select();
      }
    }
    if (e.key === "ArrowDown") {
      if (ActiveIndex >= 1 && ActiveIndex < maxTab) {
        if (
          ActiveIndex + 1 === ListTabOrder.ProductTableListTab &&
          EntTransDT.length > 0
        ) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex + 1) + "']").select();
        }
      } else {
        $("[tabindex='" + 1 + "']").focus();
        $("[tabindex='" + 1 + "']").select();
      }
    }
    if (e.key === "ArrowUp") {
      if (ActiveIndex > 0 && ActiveIndex <= maxTab) {
        if (
          ActiveIndex - 1 === ListTabOrder.ProductTableListTab &&
          EntTransDT.length > 0
        ) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex - 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex - 1) + "']").select();
        }
      } else {
        if (
          maxTab - 1 === ListTabOrder.ProductTableListTab &&
          EntTransDT.length > 0
        ) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (maxTab - 1) + "']").focus();
          $("[tabindex='" + (maxTab - 1) + "']").select();
        }
      }
    }
  };

  const PropertiesValidation = () => {
    var ErrorMsg = true;
    let ValidateItem = ListValidateProperties.filter(
      (Data) => Data.isValidate === true
    );
    for (var i = 0; i < ValidateItem.length; i++) {
      switch (ValidateItem[i].strCtrlName) {
        case "txtStoAdjNo":
          ErrorMsg = strVouchNo === "" ? false : true;
          break;
        case "txtTransNo":
          ErrorMsg = strTransNo === "" ? false : true;
          break;
        case "txtDescription":
          ErrorMsg = strDescription === "" ? false : true;
          break;
        default:
          break;
      }
      if (ErrorMsg === false) {
        Show_Message(dispatch, ValidateItem[i].strErrorMsg, "error");
        return ErrorMsg;
      }
    }
    return ErrorMsg;
  };

  const ButtonPermission = async () => {
    try {
      if (!_AuthParems || !_AuthParems.jbctrlparams) {
        console.log("jbctrlparams missing:", _AuthParems);
        return;
      }

      const AuthParems = await DecryptData(_AuthParems.jbctrlparams);

      if (!AuthParems || !AuthParems.PurchasePer) {
        console.log("Permission data missing:", AuthParems);
        return;
      }

      let ListMenu = AuthParems.PurchasePer.find(
        (Data) => Data.iScrId === iScrId
      );

      if (!ListMenu) {
        console.log("No permission found for screen:", iScrId);
        return;
      }

      setisBtnSave(iStoAdjId > 0 ? !ListMenu.isModify : !ListMenu.isCreate);
      setisBtnDelete(!ListMenu.isDelete);
      setisBtnView(!ListMenu.isView);
    } catch (err) {
      console.log("Permission Error:", err);
    }
  };

  const TransColum = [
    { accessor: "sNo", Header: "SNo" },
    { accessor: "proCode", Header: "Code" },
    { accessor: "proName", Header: "Product Name" },
    { accessor: "qty", Header: "Qty" },
    { accessor: "rateWithoutTax", Header: "Rate" },
    { accessor: "goodsValue", Header: "Goods Value" },
    { accessor: "itemAmt", Header: "Amount" },
    { accessor: "reason", Header: "Reason" },
  ];

  return (
    <>
      <SideMenu ScrId={iScrId} />
      <div className="Trans-container">
        <div className="Trans-card">
          <div className="Trans-wrapper">
            <div className="row">
              <div className="col-md-3 col-sm-12 mt-1">
                <label>
                  Trans No <span className="danger">*</span>
                </label>
                <input
                  type="text"
                  aria-label="First name"
                  className="form-control"
                  id="txtTransNo"
                  name="strTransNo"
                  readOnly
                  value={strTransNo}
                  onChange={(e) => setstrTransNo(e.target.value)}
                  tabIndex={ListTabOrder.txtTransNo}
                  autoFocus
                  onKeyDown={(e) => KeyDown(e)}
                />
              </div>
              <div className="col-md-3 col-sm-12 mt-1">
                <label>
                  Vocher no <span className="danger">*</span>
                </label>
                <div className="d-inline-flex " style={{ width: "100%" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Voucher Number"
                    aria-label="Recipient's username"
                    value={strVouchNo}
                    aria-describedby="button-addon2"
                    id="txtVoucherNo"
                    name="strVouchNo"
                    onChange={(e) => setstrVouchNo(e.target.value)}
                    tabIndex={ListTabOrder.txtStoAdjNo}
                    onKeyDown={(e) => KeyDown(e)}
                  />
                </div>
              </div>
              <div className="col-md-3 col-sm-12">
                <label>
                  Date <span className="danger">*</span>
                </label>
                <input
                  type="date"
                  name="strVouchDate"
                  className="form-control"
                  value={strVouchDate}
                  onChange={(e) => setstrVouchDate(e.target.value)}
                  tabIndex={ListTabOrder.dpStoAdjDate}
                  onKeyDown={(e) => KeyDown(e)}
                />
              </div>
              <div className="col-md-3 col-sm-12 mt-1">
                <label>Description</label>
                <textarea
                  className="form-control rounded"
                  aria-label="With textarea"
                  placeholder="Description"
                  style={{ height: "90px" }}
                  id="strDescription"
                  value={strDescription}
                  onChange={(e) => setstrDescription(e.target.value)}
                  tabIndex={ListTabOrder.txtDescription}
                  onKeyDown={(e) => KeyDown(e)}
                ></textarea>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-3">
                <label>Product Name</label>
                <div style={{ position: "relative" }}>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Select Product"
                    value={_Proparem.strProName}           /* ✅ BUG FIX 1: defaultValue→value (controlled input, updates on Redux state change) */
                    onChange={() => { }}                    /* ✅ empty onChange — no readOnly (readOnly makes input grey) */
                    onClick={() =>
                      dispatch(
                        ShowHide_Popup({
                          isshow: "IsProSearch",
                          Scrtype: "Purchase",
                        })
                      )
                    }
                  />
                  <i
                    className="fa-solid fa-caret-down"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "10px",
                      color: "darkgreen",
                    }}
                  ></i>
                </div>
              </div>
              <div className="col-md-1 col-sm-12">
                <label>Qty</label>
                <input
                  type="text"
                  aria-label="First name"
                  className="form-control"
                  name="dQty"
                  id="dQty"
                  value={_Proparem.dQty}
                  onChange={(e) =>
                    dispatch(StockQty_Onchange(Number(e.target.value)))
                  }
                  onClick={(e) => e.target.select()}
                  tabIndex={ListTabOrder.txtQty}
                  onKeyDown={(e) => KeyDown(e)}
                />
              </div>
              <div className="col-md-2 col-sm-12">
                <label>Unit</label>
                <div>
                  <CustomizedSelectoption
                    key={`${_Proparem.iProId}-${_Proparem.iUnitId}`}  /* ✅ remount on product OR unit change */
                    optionparem="isoptionShow"
                    showoption={_selecrparem?.isoptionShow ?? false}
                    placeholder="Unit"
                    select_value={(item) =>                     // ✅ val → item
                      dispatch(
                        Select_Unit({
                          UnitId: Number(item.iUnitId),         // ✅ item.iUnitId
                          strUnitName: item.strUnitName,        // ✅ item.strUnitName
                          dPriceRate: _Proparem.dRate,
                        })
                      )
                    }
                    taborder={ListTabOrder.cbUnit}
                    keydown={(e) => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown");
                      else KeyDown(e);
                    }}
                    btnname="Unit"
                    btnshow={false}
                    show_popup=""
                    valueonly={false}                           // ✅ false — full item கிடைக்கும்
                    defaultval={_Proparem?.iUnitId ?? 0}              // ✅ FIX: lowercase v + iUnitId number (not name string!)
                    displayName="strUnitName"
                    disvalue="iUnitId"
                    arrydata={_Proparem.Unit ?? []}
                    disabled={false}
                    EmptVal="Unit"
                  />
                </div>
              </div>
              <div className="col-md-1 col-sm-12">
                <label>Rate</label>
                <input
                  type="number"
                  aria-label="First name"
                  className="form-control"
                  name="dRate"
                  id="dRate"
                  value={_Proparem.dRate}
                  onChange={(e) =>
                    dispatch(
                      ProductRate_Onchange({
                        Name: "dRate",
                        Value: Number(e.target.value).toFixed(2),
                      })
                    )
                  }
                  onClick={(e) => e.target.select()}
                  tabIndex={ListTabOrder.txtRate}
                  onKeyDown={(e) => KeyDown(e)}
                />
              </div>
              <div className="col-md-3 col-sm-12">
                <label>Reason</label>
                <input
                  type="text"
                  aria-label="First name"
                  className="form-control"
                  name="strReason"
                  id="strReason"
                  value={_Proparem.Reason}
                  onChange={(e) =>
                    dispatch(StockAdjutment_Onchange(e.target.value))
                  }
                  onClick={(e) => e.target.select()}
                  placeholder="Enter Adjustment Reason"
                  tabIndex={ListTabOrder.txtReason}
                  onKeyDown={(e) => KeyDown(e)}
                />
              </div>
              <div className="col-md-1 col-sm-12 d-flex justify-content-center align-items-center mt-4">
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={AddProductClick}
                  tabIndex={ListTabOrder.btnAdd}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") AddProductClick();
                    else KeyDown(e);
                  }}
                  style={{
                    fontWeight: "bold",
                    fontSize: "10px",
                    borderRadius: "7px",
                    color: "darkgreen",
                  }}
                >
                  Add
                </button>
              </div>
            </div>
            <ReactTable
              columns={TransColum}
              data={EntTransDT}
              minRows={5}
              row_click={(rowInfo, Index) => {
                setselected(Index);
              }}
              row_doubleclick={(rowInfo, Index) => {
                AssignSelectedProduct(Index, rowInfo);
              }}
              background={true}
              tabIndex={12}
              className="full-table"
            />
            <div className="row">
              <div className="col-sm-12 col-md-3 mt-2">
                <label>Total Qty</label>
                <input
                  id="txtTotQty"
                  aria-label="First name"
                  className="form-control"
                  style={{ textAlign: "right" }}
                  value={dTQty}
                  readOnly
                />
              </div>
              <div className="col-sm-12 col-md-3 mt-2">
                <label>Total Goods Value</label>
                <input
                  id="txtTotGoodsVal"
                  aria-label="First name"
                  className="form-control"
                  style={{ textAlign: "right" }}
                  value={dGoodVal}
                  readOnly
                />
              </div>
              <div className="col-sm-12 col-md-3 mt-2">
                <label>Round Off</label>
                <input
                  id="txtTotRF"
                  aria-label="First name"
                  className="form-control"
                  style={{ textAlign: "right" }}
                  value={dRoundOff}
                  readOnly
                />
              </div>
              <div className="col-md-3 col-sm-12 mt-2">
                <div className="net-amount">
                  <h1>NET AMOUNT</h1>
                  <h2>
                    {new Intl.NumberFormat("en-GB", {
                      style: "currency",
                      currency: "INR",
                    }).format(Number(dNetAmt).toFixed(2))}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="btn-section">
            <button
              type="button"
              className="btn-fabgreen"
              disabled={isBtnSave}
              onClick={(e) => {
                if (PropertiesValidation()) {
                  Ask_Question(
                    dispatch,
                    SaveClick,
                    iStoAdjId > 0
                      ? "Do You Want to Update Stock Adjustment?"
                      : "Do You Want to Save Stock Adjustment?"
                  );
                }
              }}
              tabIndex={ListTabOrder.btnSave}
              onKeyDown={(e) => KeyDown(e)}
            >
              Save &nbsp; <i className="fas fa-save"></i>
            </button>
            <button
              type="button"
              className="btn-fabgreen"
              tabIndex={ListTabOrder.btnClear}
              onKeyDown={(e) => KeyDown(e)}
              onClick={ClearClick}
            >
              Clear &nbsp; <i className="fas fa-eraser"></i>
            </button>
            <button
              disabled={isBtnView}
              type="button"
              className="btn-fabgreen"
              onClick={(e) => setisTrans(!isTrans)}
              tabIndex={ListTabOrder.btnView}
              onKeyDown={(e) => KeyDown(e)}
            >
              View &nbsp; <i className="fas fa-eye"></i>
            </button>
            <button
              type="button"
              disabled={isBtnDelete}
              className="btn-fabgreen"
              onClick={(e) => {
                Ask_Question(
                  dispatch,
                  DeleteClick,
                  "Do You Want to Delete Stock Adjustment?"
                );
              }}
              tabIndex={ListTabOrder.btnCancel}
              onKeyDown={(e) => KeyDown(e)}
            >
              Delete &nbsp; <i className="far fa-trash-alt"></i>
            </button>
            <button
              type="button"
              className="btn-fabgreen"
              tabIndex={ListTabOrder.btnClose}
              onKeyDown={(e) => KeyDown(e)}
              onClick={() => (window.location.href = "/JustBill/DashBoard")}
            >
              Close &nbsp; <i className="fas fa-times"></i>
            </button>
          </div>
          {isTrans && (
            <CustomTransView
              Close={(e) => setisTrans(!isTrans)}
              View_Invoice={View_StcokAdjustment}
              ScrId={iScrId}
              Title="Stock AdjustMent"
              ScrName="Transaction"
            />
          )}
          {_Common.IsProSearch && (
            <MasterProductSearch
              iScrId={iScrId}
              strScrType="Purchase"
              iPartyId={0}
              iTaxRelId={1}
              disabled={false}
            />
          )}
          <Messagedialogbox />
        </div>
      </div>
    </>
  );
}

export default StockAdjustment;